// extracted by mini-css-extract-plugin
module.exports = {"button":"a10a3f92e9--button--ZTvoK","container":"a10a3f92e9--container--VJKkg","tooltip":"a10a3f92e9--tooltip--TJ510","bargain":"a10a3f92e9--bargain--Ig1JG"};